export default { user: {}, playing: {}, queue: [], playlist: [], playingQueue: [], likes: [], recents: [] };
